import { createTheme, rem } from '@mantine/core';

/**
 * Mantine theme configuration matching the screener_frontend styling
 */
export const theme = createTheme({
  colors: {
    // Colors from screener theme
    blue: [
      '#E2FBFF',
      '#D0F2FD',
      '#A4E2F6',
      '#75D2EF',
      '#4FC4E9',
      '#36BBE6',
      '#23B7E5',
      '#0AA0CC',
      '#008FB7',
      '#007DA2',
    ],
    green: [
      '#E7FFFA',
      '#D4FAF4',
      '#A9F4E8',
      '#7CEFDB',
      '#59EAD0',
      '#44E7CA',
      '#36E6C6',
      '#26CBAE',
      '#14B59B',
      '#009D85',
    ],
    pink: [
      '#FFE8FA',
      '#FFCFED',
      '#FD9DD7',
      '#FB68C1',
      '#FA3CAD',
      '#F922A3',
      '#FA139D',
      '#DF0488',
      '#C80079',
      '#B00069',
    ],
    purple: [
      '#F4ECFF',
      '#E3D7FB',
      '#C2AEEE',
      '#A081E3',
      '#835BD9',
      '#7143D4',
      '#6737D2',
      '#5729BA',
      '#4C24A8',
      '#421C94',
    ],
    red: [
      '#FFE9E9',
      '#FFD2D2',
      '#FAA1A2',
      '#F56E6E',
      '#F14343',
      '#F02827',
      '#F01919',
      '#D60A0D',
      '#BF020A',
      '#A80005',
    ],
    yellow: [
      '#FFFAE1',
      '#FEF3CC',
      '#FCE79D',
      '#F8DA69',
      '#F6CE3F',
      '#F5C722',
      '#F4C30F',
      '#D9AC00',
      '#C19900',
      '#A78300',
    ],
  },
  defaultRadius: '3px',
  fontFamily: 'Poppins, Inter, system-ui, -apple-system, sans-serif',
  fontSizes: {
    xs: rem(12.64),
    sm: rem(14.22),
    md: rem(16.0),
    lg: rem(18.0),
    xl: rem(20.25),
  },
  headings: {
    fontFamily: 'Poppins, Inter, system-ui, -apple-system, sans-serif',
    fontWeight: '700',
    sizes: {
      h1: { fontSize: rem(28.83), lineHeight: '1.18' },
      h2: { fontSize: rem(25.63), lineHeight: '1.23' },
      h3: { fontSize: rem(22.78), lineHeight: '1.30' },
      h4: { fontSize: rem(20.25), lineHeight: '1.36' },
      h5: { fontSize: rem(18.0), lineHeight: '1.43' },
      h6: { fontSize: rem(16.0), lineHeight: '1.50' },
    },
  },
  lineHeights: {
    xs: '1.3',
    sm: '1.4',
    md: '1.5',
    lg: '1.6',
    xl: '1.7',
  },
  primaryShade: 5,
  primaryColor: 'purple',
  respectReducedMotion: true,
});
